module.exports = __webpack_public_path__ + "img/ali-logo.svg";